import {
  CACHE_KEY_UNFINISHED_APPLICATION_DATA,
  CACHE_KEY_UNFINISHED_APPLICATION_ID,
} from '@application/constants';
import type { ApplicationPageFormValues } from '@presentation/pages';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';

export const useSavedApplication = () => {
  const { pathname } = useLocation();
  const [isUnfinished, setUnfinished] = useState<boolean>(false);

  const application: ApplicationPageFormValues | null = useMemo(() => {
    if (typeof window !== 'undefined') {
      const data = localStorage.getItem(CACHE_KEY_UNFINISHED_APPLICATION_DATA);
      if (data) {
        return JSON.parse(data);
      }
    }
    return null;
  }, [pathname]);

  const breederId = useMemo(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(CACHE_KEY_UNFINISHED_APPLICATION_ID);
    }
    return null;
  }, [pathname]);

  const saveApplication = useCallback((id: number, data: ApplicationPageFormValues) => {
    localStorage.setItem(CACHE_KEY_UNFINISHED_APPLICATION_ID, String(id));
    localStorage.setItem(CACHE_KEY_UNFINISHED_APPLICATION_DATA, JSON.stringify(data));
    setUnfinished(true);
  }, []);

  const closePopup = useCallback(() => {
    setUnfinished(false);
  }, []);

  const clearOngoingApplication = useCallback(() => {
    localStorage.removeItem(CACHE_KEY_UNFINISHED_APPLICATION_DATA);
    localStorage.removeItem(CACHE_KEY_UNFINISHED_APPLICATION_ID);
    closePopup();
  }, [closePopup]);

  useEffect(() => {
    const id = localStorage.getItem(CACHE_KEY_UNFINISHED_APPLICATION_ID);
    setUnfinished(!!id);
  }, [pathname]);

  return {
    isUnfinished,
    breederId,
    saveApplication,
    closePopup,
    clearOngoingApplication,
    application,
  };
};
